// Modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RoutingModule } from './routing.module';
import { MaterialModule } from './material.module';

// Feature Modules
import { LocationModule } from '../location/location.module';
import { TeamModule } from '../team/team.module';
import { SurveyModule } from '../survey/survey.module';

// Services
import { AuthService } from './Services/auth.service';
import { SharedService } from './Services/shared.service';
import { NotificationService } from './Services/notification.service';
import { ExternalResourceService } from './Services/externalresource.service';
import { CmsMenuService } from './Services/cmsmenu.service';

// Components
import { CoreComponent, CallbackComponent } from './core.component';
import { LoaderComponent } from './Components/shared/loader/loader.component';
import { DialogComponent } from './Components/shared/dialog/dialog.component';
import { HomeComponent } from './Components/home/home.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { XHRIntercept } from './Services/HTTPInterceptor';
import { MemberListBoxComponent } from './Components/shared/member-listbox/member-listbox.component';
import { ItemAddComponent } from './Components/shared/item-add/item-add.component';
import { ExternalResourceComponent } from './Components/dashboard/external-resource/external-resource.component';
import { PushNotificationComponent } from './Components/dashboard/push-notification/push-notification.component';
import { CmsMenuComponent } from './Components/dashboard/cms-menu/cms-menu.component';

@NgModule({
    declarations: [
        CoreComponent, CallbackComponent,
        LoaderComponent, DialogComponent,
        MemberListBoxComponent, ItemAddComponent,
        HomeComponent, DashboardComponent, CmsMenuComponent,
        ExternalResourceComponent, PushNotificationComponent
    ],
    imports: [
        BrowserModule, BrowserAnimationsModule, FormsModule,
        HttpClientModule, RoutingModule, MaterialModule,

        // Feature Modules
        LocationModule, TeamModule, SurveyModule
    ],
    entryComponents: [DialogComponent, MemberListBoxComponent, ItemAddComponent],
    providers: [
        AuthService, SharedService, NotificationService,
        { provide: HTTP_INTERCEPTORS, useClass: XHRIntercept, multi: true },
        ExternalResourceService, CmsMenuService
    ],
    bootstrap: [CoreComponent]
})

export class CoreModule {}